import type { TFunction } from 'i18next';
import { APPLICATION_SOURCES, GENDERS, GUARDIAN_RELATIONSHIPS } from '@/types/shared';

export interface EnumOption<T extends string> {
  value: T;
  label: string;
}

/** Bilingual option lists for the shared enums (`packages/shared/src/enums/student.enum.ts`) —
 * labels come from `enums.*` in `ar.json`/`en.json`, never hardcoded per-language strings. */
export function genderOptions(t: TFunction): EnumOption<(typeof GENDERS)[number]>[] {
  return GENDERS.map((value) => ({ value, label: t(`enums.gender.${value}`) }));
}

export function guardianRelationshipOptions(
  t: TFunction,
): EnumOption<(typeof GUARDIAN_RELATIONSHIPS)[number]>[] {
  return GUARDIAN_RELATIONSHIPS.map((value) => ({
    value,
    label: t(`enums.guardianRelationship.${value}`),
  }));
}

export function applicationSourceOptions(
  t: TFunction,
): EnumOption<(typeof APPLICATION_SOURCES)[number]>[] {
  return APPLICATION_SOURCES.map((value) => ({
    value,
    label: t(`enums.applicationSource.${value}`),
  }));
}
